document.addEventListener('DOMContentLoaded', function load() {
 
   function replacePWimages(selector) {
    var textArray = $(selector);

    textArray.each(function () {
        var text = $(this).text();
        var cardIDMatch = text.match(/PersonalisationID:\s*([^\s]+)/);

        if (cardIDMatch && cardIDMatch[1]) {
            var cardID = cardIDMatch[1];
            var rand = Math.floor(Math.random() * 10000);
            var newSrc = "https://pwcdn.net/thumbnails/1586/" + cardID + ".jpg?r=" + rand;

            var $img = $(this).parent().find("img");
            $(this).parent().addClass("pwProductItem");
            $img.addClass("pwThumbImage");
            $img.attr("src", newSrc);
            $img.attr("srcset", newSrc);
        }
    });
}

  if($("body").hasClass("template-cart")){
    // Call the function with your target selector
     replacePWimages(".t4s-cartPage__items .t4s-page_cart__item .t4s-page_cart__info");
  }

    $(document).on("click", ".t4s-product-form__submit, .t4s-icon.t4s-icon--cart", function(){
        setTimeout(function(){ 
        	replacePWimages(".t4s-mini_cart__items .t4s-mini_cart__item .t4s-mini_cart__info");
        },2000);
      });

}, false);